module.exports = __webpack_public_path__ + "img/div6-4.62cd8cee.jpg";